module.exports = __webpack_public_path__ + "img/left-single.94f5f3d1.svg";